module.exports = __webpack_public_path__ + "img/img2.18cfdf67.png";